module.exports = __webpack_public_path__ + "static/media/template4.b240aa30.webp";